import React, { useContext, useEffect, useState } from "react";
import "./Blogs.css";
import Common_breadcrumb from "../common_components/common_breadcrumb/Common_breadcrumb";
import Common_Heading from "../common_components/common_Heading/Common_Heading";
import Blog_card from "./blog_card/Blog_card";
import Purple_border_btn from "../common_components/common_btn/purple_border_btn/Purple_border_btn";
import Purple_Btn from "../common_components/common_btn/purple_btn/Purple_Btn";
import { Link } from "react-router-dom";
import { Insights } from "../../utils/luxuryapis/Event/Event";
import { Context } from "../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Blogs() {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "Insight" },
  ];
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const getAllData = async (currentPage, per_page) => {
    const res = await Insights(currentPage, per_page);
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllData(currentPage, data?.per_page);
  }, [currentPage]);

  const blogsPerPage = data?.per_page;

  const totalPages = data?.totalPages;

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;

  // ✅ Next Page
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      window.scrollTo(0, 0);
    }
  };

  // ✅ Previous Page
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      window.scrollTo(0, 0);
    }
  };

  const { IMG_URL } = useContext(Context);

  return (
    <>
      <section className="Blogs">
        <div className="custom_container">
          <Common_breadcrumb items={breadcrumbItems} />
          {data?.data?.length > 0 ? (
            <>
              <div className="heading_holder">
                <Common_Heading
                  headingText={"LATEST UPDATES"}
                  subHeadingText={"You never want to miss"}
                />
              </div>

              <div className="blog_card_holder">
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-md-12">
                    {data?.data?.map((blog) => (
                      <Link to={`/luxury/articles-details/${blog?.id}`}>
                        <Blog_card
                          key={blog.id}
                          blog={blog}
                          IMG_URL={IMG_URL}
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <div className="btn_holder">
                <div>
                  <Purple_border_btn
                    btnText="Previous Page"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  />
                </div>

                <div>
                  <Purple_Btn
                    btnText="Next Page"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  />
                </div>
              </div>

              <div className="page_count_text">
                Page {currentPage} of {totalPages}
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 0",
                  color: "#888",
                }}
              >
                <FontAwesomeIcon
                  icon="fa-solid fa-box-open"
                  style={{ fontSize: "40px", marginBottom: "10px" }}
                />
                <p style={{ fontSize: "18px", margin: 0 }}>No Data Available</p>
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
}

export default Blogs;
